<template>
  <v-content class="learn-content">
    <h1 class="blue--text">Homepage</h1>
    <v-btn depressed flat class="pink">Login</v-btn>
  </v-content>
</template>
<script>
export default {};
</script>
